jQuery(function($) {
	$( '.toggle-video-special' ).click( function() {
		var ClickedElementWidth = $( this ).width();
		var ClickedElementHeight = $( this ).height();

		video = '<iframe src="' + $( this ).attr( 'data-video' ) + '"></iframe>';

		$( this ).replaceWith( $( video ) );

		// Created Element Iframe
		var CreatedElementIframe = $('.dzien-babci-i-dziadka__content-video iframe' );

		CreatedElementIframe.css( 'width', ClickedElementWidth + 'px' );
		CreatedElementIframe.css( 'height', ClickedElementHeight + 'px' );
	});
});
